export const state = {
  lang: "fr",
  t: [
    {
      word:"best For you",
      en:"best For you",
      fr:"le meilleur pour vous",
      ar:"الأفضل لكم"
    },
    {
      word:"g1",
      en:"The validity period is 3 years.",
      fr:"The validity period is 3 years.",
      ar:"The validity period is 3 years.",
    },
    {
      word:"p1",
      en:"The validity period is 2 years.",
      fr:"The validity period is 2 years.",
      ar:"The validity period is 2 years.",
    },
    {
      word:"c1",
      en:"The validity period is 1 years.",
      fr:"The validity period is 1 years.",
      ar:"The validity period is 1 years.",
    },
    {
      word:"g2",
      en:"Balance discounts up to 700,000 DA on all services",
      fr:"Balance discounts up to 700,000 DA on all services",
      ar:"",
    },
    {
      word:"p2",
      en:"Balance discounts up to 350,000 DA on all services",
      fr:"Balance discounts up to 350,000 DA on all services",
      ar:"",
    },
    {
      word:"c2",
      en:"Balance discounts up to 120,000 DA on all services",
      fr:"Balance discounts up to 120,000 DA on all services",
      ar:"",
    },
    {
      word:"g3",
      en:"Discounts of up to 50% on more than 419 hospitals inside and outside the country",
      fr:"Discounts of up to 50% on more than 419 hospitals inside and outside the country",
      ar:"",
    },
    {
      word:"g4",
      en:"Discounts of up to 50% on car insurance",
      fr:"Discounts of up to 50% on car insurance",
      ar:"",
    },
    {
      word:"g5",
      en:"A discounts of up to 75% on Turkish universities",
      fr:"A discounts of up to 75% on Turkish universities",
      ar:"",
    },
    {
      word:"g6",
      en:"Discounts on hotels / Umrah / tourisme trips",
      fr:"Discounts on hotels / Umrah / tourisme trips",
      ar:"",
    },
    {
      word:"g7",
      en:"Discounts on child care and nurseries",
      fr:"Discounts on child care and nurseries",
      ar:"",
    },
    {
      word:"g8",
      en:"Possibility of payment by installments payment for treatment abroad",
      fr:"Possibility of payment by installments payment for treatment abroad",
      ar:"",
    },
    {
      word:"g9",
      en:"Ambulance.",
      fr:"Ambulance.",
      ar:"",
    },
    {
      word:"g10",
      en:"Medical tests in your home",
      fr:"Medical tests in your home",
      ar:"",
    },
    {
      word:"g11",
      en:"Benefit from the blood bank",
      fr:"Benefit from the blood bank",
      ar:"",
    },
    {
      word:"g12",
      en:"All family members benefit from the discounts",
      fr:"All family members benefit from the discounts",
      ar:"",
    },
    {
      word:"g13",
      en:"All mentioned services will be available before the end of 2023",
      fr:"All mentioned services will be available before the end of 2023",
      ar:"",
    },
    {
      word:"Choisissez qui peut réaliser vos rêves et ceux de votre famille, choisissez ISO ASSURANCE.",
      fr:"Choisissez qui peut réaliser vos rêves et ceux de votre famille, choisissez ISO ASSURANCE.",
      en:"CHOOSE WHO CAN MAKE YOUR DREAMS COME TRUE ",
      ar:"CHOOSE WHO CAN MAKE YOUR DREAMS COME TRUE "
    },
    {
      word:"Nous sommes présents en Algérie et à l’étranger.",
      fr:"Nous sommes présents en Algérie et à l’étranger.",
      en:"We are present in Algeria and aboard .",
      ar:"",
    },
    {
      word:"studyTurk",
      fr:"Choisissez le programme et l'université En Turquie il s'agit de centaines d'universités qui ont a leur tour des milliers de spécialités pour les différents niveaux d'étude. La première étape pour vos inscriptions est de préciser le domaine et la spécialité que vous souhaitez étudier.Vous pouvez également choisir parmis les nombreuses universités privé disponible pour l inscriptions auprès de nous. Groupe ISO représenté pas son équipe qui ont obtenu plusieurs certificat dans la délégation pédagogique fournit ses services pour les étudiants qui souhaitent étudier en étranger et précisément en Europe et en Turquie. ISO Assurance Est le meilleur agent éducatif pour plus que 50 universités en Turquie .C'est pour quoi  les étudiants qui postulent dans les universités Turque par notre intermédiaire il bénéficient des remises  allant jusqu'à 75% sachant que tous nos services sont gratuits et ne nous facturons aucun frais d inscription dans les universités privés Turque.",
      en:"Do you want to study in Turkey?\nAre you looking for university to start your university journey with discounted fees and exclusive offers?\nISO GROUP, represented by its distinguished team, which holds several certificates in educational consultancy, provide sits services to students wishing to study abroad, specifically in Turkey and Europe.\n\nISO ASSURANCE is the best educationalagency for more than 50 universities in Turkey, and for this reason, students who apply to Turkish universities through us get special discounts on tuition fees up to 75%.\nOur services are for free 100%.We don’t charge any fees for the regestration in private Turkish universities  .",
      ar:"",
    },
    {
      word:"En collaboration avec des partenaires de renommée, nous proposonsaux membres ISO Assurance des offres optimales et des services d’intermédiation d’exception dans le domaine des assurances. Les secteurs d’activité couverts sont : la santé, les voyages, l’université, les crèches et tout type d’assurance «biens et personnes».",
      fr:"En collaboration avec des partenaires de renommée, nous proposons aux membres ISO Assurance des offres optimales et des services d’intermédiation d’exception dans le domaine des assurances. Les secteurs d’activité couverts sont : la santé, les voyages, l’université, les crèches et tout type d’assurance «biens et personnes».",
      ar:"En collaboration avec des partenaires de renommée, nous proposonsaux membres ISO Assurance des offres optimales et des services d’intermédiation d’exception dans le domaine des assurances. Les secteurs d’activité couverts sont : la santé, les voyages, l’université, les crèches et tout type d’assurance «biens et personnes».",
      en:"With coloboration with renowmed partenaries, ISO ASSURANCE offer members , optimal offers and exceptional inertmidiation services for expectaion on the fieald of inssurance .\nThe serctor of activty coverd are « health , travel and tourism , nurseries , universities and  all types of insurance  (property and personal) ».",
    },
    {
      word:"Après les voyages, ISO rejoint le domaine des assurances.\n ISO ASSURANCE propose des services visant plusieurs secteurs d’activité « santé, voyages, crèches et garderies, universités et agences d’assurance ».  ",
      fr:"Après les voyages, ISO rejoint le domaine des assurances.\n ISO ASSURANCE propose des services visant plusieurs secteurs d’activité « santé, voyages, crèches et garderies, universités et agences d’assurance ».  ",
      en:"after TRAVEL, ISO joins the insurance field. ISO ASSSURANCE offer srvices to serval many sectors of activities « health ,travel and tourism , child care and nurseries , universities and insurance agencies ».",
      ar:""
    },
    {
      word: "aboutUs",
      fr: "Nous sommes une entreprise, crée en 2019. Nous offrons l’intermédiation entre des clients « particuliers et grands comptes » et des partenaires « prestataires de services » dans plusieurs secteurs d’activité. Nous couvrons actuellement deux secteurs d’activité « tourisme et voyage et assurances ». Notre portefeuille partenaires compte + de 1000 partenaires nationaux et internationaux. \n Nous offrons des services optimums dans les secteurs de la santé, le tourisme, l’assurance des biens et des personnes, l’université et les crèches, aussi bien à nos partenaires qu’à nos clients.\n Concernant ces derniers, qui forment un réseau de + de 25000 membres, bénéficient de multiples avantages en terme de services, prise en charge et coût avec leur carte de membre ISO.\n Notre ambition est d’élargir notre champ d’intervention au niveau national et international et d’agrandir nos réseaux de partenaires et de clients pour atteindre un portefeuille clients + de 100 000 et un portefeuille partenaires + de 2000 à l’horizon 2025.",
      ar: "التأمين الصحي هو أحد أنواع التأمين ضد مخاطر الظروف الصحية ويشمل تكاليف الفحص والتشخيص والعلاج والدعم النفسي والبدني. يتكون التأمين الصحي من الطرف الأول شركة التأمين والطرف الثاني هو عقد المستفيد وشروطه من التغطية \n ISO Assurance هي شركة تأمين صحي موجودة في ثلاث دول في العالم ، تركيا وتونس والجزائر ، فهي أول شركة موجودة في الجزائر في هذا المجال. أنفقت ISO Assurance عقودًا مع أكثر من أربع شركات كبرى في الجزائر ، كل شركة لديها حوالي 2500 عامل ضمانات ISO لكل عامل بخصومات تتراوح من 20 إلى 30٪ من تكاليف الفحوصات الطبية والتشخيصات العلاجية في أكثر من 1000 مستشفى وعيادة طبية ، بالإضافة إلى توفير تسهيلات السداد في بعض الحالات. تمنح ISO Assurnce بطاقة ولاء لكل عامل بلاتينيوم صالحة لمدة سنتين ذهبية صالحة لمدة 3 سنوات كلاسيكية صالحة لمدة سنة واحدة.",
      en: "We are created in 2019,we offer the untermediation between constumers « individual and large account « and parternaries (service provider ) in many sector of activity .\nWe currently coverd two sectors of activity(travel ,tourisme and insurance) .\nOur partener portfilio includes more than 1000 national and international parteners .\nWe offer optimum sevices in the sector of health , tourism and  property and personal insurrance ,university and nurserries both to our parteners and our constumers .\nRegading these,who form a network of more than 25.000 members ;benifit from multiple adventages in terms of services ,assumtion and   cost with   thier ISO membership card .",
      tu: "Sağlık sigortası, sağlık durumlarının risklerine karşı sigorta türlerinden biridir ve muayene, teşhis, tedavi ile psikolojik ve fiziksel destek masraflarını içerir. Sağlık sigortası aşağıdakilerden oluşur: Birinci taraf sigorta şirketidir İkinci taraf hak sahibidir Sözleşme ve şartlar kapsama alanı \n ISO Güvence, Cezayir'de bu alanda faaliyet gösteren ilk şirket olması nedeniyle dünyada Türkiye, Tunus ve Cezayir olmak üzere üç ülkede faaliyet gösteren bir sağlık sigortası şirketidir. ISO Güvencesi, Cezayir'deki dörtten fazla büyük şirketle sözleşme imzaladı, her şirketin yaklaşık 2500 çalışanı var. bazı durumlarda ödeme kolaylığı sağlamanın yanı sıra. ISO güvencesi her çalışana bir sadakat kartı verir platin iki yıl geçerli altın 3 yıl geçerli klasik 1 yıl geçerli.",
    },
    
    {
      word:"be a partner",
      en:"be a partner",
      fr:"être partenaire",
      ar:"كن شريكا",
    },
    {
      en: "Send Request",
      word: "Send Request",
      fr: "Envoyer demande",
      ar: "ارسال الطلب",
      tu: "İstek gönder",
    }, //
    {
      en: "Card Type",
      word: "Card Type",
      fr: "Type de carte",
      ar: "نوع البطاقة",
    },
    
    {
      en: "GPS Link",
      word: "GPS Link",
      fr: "Liaison GPS",
      ar: "رابط GPS",
    },
    {
      en: "Liste View",
      word: "Liste View",
      fr: "Voir Liste",
      ar: "عرض القائمة",
    },
    {
      en: "clinics",
      word: "clinics",
      fr: "cliniques",
      ar: "عيادات",
    },
    {
      en: "languages",
      word: "languages",
      fr: "langues",
      ar: "اللغات",
    },
    {
      en: "download the app",
      word: "download the app",
      fr: "télécharger l'application",
      ar: "قم بتنزيل التطبيق",
    },
    {
      en: "You Can now download the app from Google Play and App Store",
      word: "You Can now download the app from Google Play and App Store",
      ar: "يمكنك الآن تنزيل التطبيق من Google Play و App Store",
      fr: "Vous pouvez maintenant télécharger l'application depuis Google Play et App Store",
    },
    {
      en: "For A Professional Partnership Contact",
      word: "For A Professional Partnership Contact",
      fr: "Pour un partenariat professionnel Contact",
      ar: "للحصول على شراكة مهنية الاتصال",
    },
    {
      en: "contact",
      word: "contact",
      fr: "contactez-nous",
      ar: "اتصل بنا",
    },
    {
      en: "Golden",
      word: "Golden",
      fr: "Gold",
      ar: "الذهبية",
    },
    {
      en: "Golden Card",
      word: "Golden Card",
      fr: "carte d'Or",
      ar: "البطاقة الذهبية",
    },
    {
      en: "Classic",
      word: "Bronze",
      fr: "Classic",
      ar: "البرونزية",
    },
    {
      en: "Bronze Card",
      word: "Bronze Card",
      fr: "Carte Bronze",
      ar: "البطاقة البرونزية",
    },
    {
      en: "Platinium",
      word: "Silver",
      fr: "Platinium",
      ar: "الفضية",
    },
    {
      en: "Silver Card",
      word: "Silver Card",
      fr: "Carte Argent",
      ar: "البطاقة الفضية",
    },
    {
      en: "Fax",
      word: "Fax",
      fr: "Fax",
      ar: "فاكس",
    },
    {
      en: "+1000 partners",
      word: "+1000 partners",
      fr: "+1000 partenaires",
      ar: "+1000 شريك",
    },
    {
      en: "English",
      word: "English",
      fr: "Anglais",
      ar: "انجليزية",
      tu: "ingilizce",
    },
    {
      en: "Show More",
      word: "show more",
      fr: "montre plus",
      ar: "أظهر المزيد",
      tu: "Daha fazla göster",
    },
    {
      en: "Show Less",
      word: "show Less",
      fr: "montre mois",
      ar: "أظهر المزيد",
    },
    {
      word: "Français",
      fr: "Français",
      ar: "فرنسية",
      en: "French",
      tu: "Fransızca",
    },
    {
      word: "العربية",
      fr: "Arabe",
      ar: "العربية",
      en: "Arabic",
      tu: "Arapça",
    },
    {
      word: "Türkçe",
      fr: "Turc",
      ar: "التركية",
      en: "Turkish",
      tu: "Türkçe",
    },
    {
      word:"bePartner",
      fr:"Rejoignez notre réseau de partenaires : Inscrivez-vous, devenez partenaire de ISO ASSURANCE et bénéficiez de ses avantages. ",
      en:"Be a partner ,joined our network , subscribe and became ISO ASSURANCE partner than benifit from their adventages .",
      ar:"",
    },
    {
      word: "TAKELOOK",
      fr: "NOUS SOMMES PARTOUT",
      ar: "نحن في كل مكان",
      en: "WE ARE EVERYWHERE",
    },
    {
      word: "is possible now",
      fr: "est possible maintenant",
      ar: "ممكن الآن",
      en: "is possible now",
    },
    {
      word: "study in turkey",
      fr: "étudier en Turquie",
      ar: "الدراسة في تركيا",
      en: "study in turkey",
    },
    {
      word: "collaborate with us",
      fr: "collaborer avec nous",
      ar: "تعاون معنا",
      en: "collaborate with us",
    },
    {
      word: "home",
      fr: "acceuil",
      ar: "الصفحة الرئيسية",
      en: "home",
    },
    {
      word: "about",
      fr: "à propos de nous",
      ar: "عنا",
      en: "about us",
    },
    {
      word: "let's be partner",
      fr: "soyons partenaire",
      ar: "لنكن شركاء",
      en: "let's be partner",
    },
    {
      word: "your favorite choice",
      ar: "اختيارك المفضل",
      fr: "votre choix préféré",
      en: "Your best choice",
    },
    {
      word: "hospitals",
      fr: "hôpitaux",
      ar: "المستشفيات",
      en: "hospitals",
      tu: "hastaneler",
    },
    {
      word: "our clients",
      fr: "nos clients",
      ar: "عملائنا",
      en: "our clients",
      tu: "müşterilerimiz",
    },
    {
      word: "login",
      fr: "connecter",
      ar: "دخول",
      en: "login",
    },
    {
      word: "and analyzes at home",
      fr: "et analyses à domicile",
      ar: "والتحاليل الطبية في المنزل",
      en: "AND MEDICAL ANALYSIS AT HOME",
    },
    {
      word:"this opportunity",
      fr:"cette opportunité",
      en:"this opportunity",
    },
    {
      word:"opportunityAgency",
      fr:"Le membre ISO Assurance bénéficie de plusieurs avantages «confort et remises sur les tarifs» sur les services offerts par nos agences d’assurances conventionnées.",
      en:"ISO ASSURANCE member benefits of many adventages «  confort and discounts for the expenses  »  of the services offerd by our approved insurance agencies .",
      ar:""
    },
    {
      word:"opportunityUniv",
      fr:"Le membre ISO Assurance bénéficie de plusieurs avantages «confort et remises sur les tarifs» sur les services offerts par nos universités conventionnées.",
      en:"ISO ASSURANCE member benefits of many adventages «  confort and discounts for the expenses  «  of the services offerd by the approved health establishement .",
    },
    {
      word:"Pour votre confort et bien-être, ISO ASSURANCE met à votre disposition des véhicules médicalisés pour votre transport et assure des prises de sang pour des examens médicaux à domicile, à travers le territoire national.",
      fr:"Pour votre confort et bien-être, ISO ASSURANCE met à votre disposition des véhicules médicalisés pour votre transport et assure des prises de sang pour des examens médicaux à domicile, à travers le territoire national.",
      en:"For your comfort and well-being ISO ASSURANCE provides you with medical vehiculs for your transoprt and provides blood samples for medical examinations at home .throught the national territory .",
      ar:"",
    },
    {
      word:"opportunityCrech",
      fr:"Le membre ISO Assurance bénéficie de plusieurs avantages «confort et remises sur les tarifs» sur les services offerts par nos crèches et garderies  conventionnées.",
      en:"ISO ASSURANCE member benefits of many adventages «  confort and discounts for the expenses  »  of the services offerd by our approved child care ,  and nurseries .",
      ar:""
    },
    {
      word:"opportunityHos",
      fr:"Le membre ISO Assurance bénéficie de plusieurs avantages «confort et remises sur les tarifs» sur les services offerts par nos établissements de santé conventionnées.",
      en:"ISO ASSURANCE member benefits of many adventages «  confort and discounts for the expenses  «  of the services offerd by the approved health establishement .",
      ar:"",
    },
    {
      word: "sign up",
      fr: "s'inscrire",
      ar: "اشتراك",
      en: "sign up",
    },
    {
      word: "ambulance +",
      fr: "ambulance +",
      ar: "سيارة إسعاف +",
      en: "ambulance +",
    },
    {
      word: "journey",
      fr: "voyage",
      ar: "رحلة",
      en: "journey",
    },{
      word: "kindergarten",
      fr: "crèche",
      ar: "روضة الاطفال",
      en: "kindergarten",
    },{
      word: "hotel",
      fr: "hôtel",
      ar: "فنادق",
      en: "hotel",
    },{
      word: "agencies",
      fr: "assurance",
      ar: "وكالات",
      en: "agencies",
    },
    { 
      word: "university",
      fr: "université",
      ar: "جامعة",
      en: "university",
    },
    {
      word: "care abroad",
      fr: "soins à l'étranger",
      ar: "العلاج في الخارج",
      en: "care abroad",
    },
    {
      word: "Ambulance",
      fr: "Ambulance",
      ar: "سياره اسعاف",
      en: "Ambulance",
    },
    {
      word: "care",
      fr: "soin",
      ar: "رعاية",
      en: "care",
    },
    {
      word: "health Service",
      fr: "service de santé",
      ar: "خدمة صحية",
      en: "health Service",
    },
    {
      word: "medical analysis",
      fr: "analyses médicales",
      ar: "تحاليل طبية",
      en: "medical analysis",
    },
    {
      word: "referral of patients",
      fr: "orientation des patients",
      ar: "إحالة المرضى",
      en: "referral of patients",
    },
    {
      word: "Our Offers",
      fr: "Nos Offres", 
      ar: "عروضنا",
      en: "Our Offers",
    },
    {
      word: "hi dear",
      fr: "salut chéri",
      ar: "مرحبًا عزيزي",
      en: "hi dear",
    },
    {
      word: "Lifetime Insurance",
      fr: "Assurance Pour tout la vie",
      ar: "تأمين مدى الحياة",
      en: "Lifetime Insurance",
    },
    {
      word: "know more",
      fr: "savoir plus",
      ar: "اعرف أكثر",
      en: "know more",
    },
    {
      word: "I'm registering",
      fr: "je m'inscris",
      ar: "أتسجل",
      en: "I'm registering",
    },
    {
      word: "and your family too",
      fr: "et votre famille aussi",
      ar: "ولعائلتك ايضا",
      en: "and your family too",
    },
    {
      word: "Insurance For you",
      fr: "Assurance Pour vous",
      ar: "تأمين لك",
      en: "Insurance For you",
    },
    {
      word: "Specialities",
      fr: "Spécialités",
      ar: "التخصصات",
      en: "Specialities",
      tu: "Uzmanlıklar",
    },
    {
      word: "Speciality",
      fr: "Spécialité",
      ar: "التخصص",
      en: "Speciality",
      tu: "Uzmanlıklar",
    },
    {
      word: "map",
      fr: "carte",
      ar: "خريطة",
      en: "map",
      tu: "harita",
    },
    {
      word: "list",
      fr: "liste",
      ar: "قائمة",
      en: "list",
      tu: "liste",
    },
    {
      word: "click to upload a photo of your id",
      fr: "cliquez pour télécharger photo de pièce d'identité",
      ar: "انقر لتحميل صورة هويتك ",
      en: "click to upload a photo of your id",
      tu: "kimliğinizin bir fotoğrafını yüklemek için tıklayın",
    },
    {
      word: "FirstName",
      fr: "Prénom",
      ar: "الاسم",
      en: "FirstName",
      tu: "İlk adı",
    }, //
    {
      word: "LastName",
      fr: "Nom",
      ar: "اللقب",
      en: "LastName",
      tu: "isim",
    },
    {
      word: "Id Photo",
      fr: "photo de piece d'identité",
      ar: "صورة لبطاقة التعريف",
      en: "Id Photo",
      tu: "kimlik kartı fotoğrafı",
    },
    {
      word: "phone",
      fr: "téléphone",
      ar: "هاتف",
      en: "phone",
      tu: "telefon",
    },
    {
      word: "adress",
      fr: "adresse",
      ar: "عنوان",
      en: "adress",
      tu: "adres",
    },
    {
      word: "seemore",
      fr: "voir plus",
      ar: "المزيد",
      en: "see more",
      tu: "daha fazla gör",
    }, //
    {
      word: "errorMsg",
      fr: "Remplissez les informations ci-dessous pour demander une carte",
      ar: "املأ المعلومات أدناه لطلب بطاقة",
      en: "Fill The informations below to request a card",
      tu: "Kart talebinde bulunmak için aşağıdaki bilgileri doldurunuz.",
    },
    {
      word: "email",
      fr: "e-mail",
      ar: "البريد الإلكتروني",
      en: "email",
      tu: "e-posta",
    },
    {
      word: "wilaya",
      fr: "Etat",
      ar: "ولاية",
      en: "state",
      tu: "durum",
    },
    {
      word: "SOCIAL MEDIA",
      fr: "MÉDIAS SOCIAUX",
      ar: "وسائل التواصل الاجتماعي",
      en: "SOCIAL MEDIA",
      tu: "SOSYAL MEDYA",
    },
    {
      word: "Our Clients",
      fr: "Nos clients",
      ar: "عملائنا",
      en: "Our Clients",
      tu: "Müşterilerimiz",
    },
    {
      word: "Sort By",
      fr: "Trier par",
      ar: "صنف حسب",
      en: "Sort By",
      tu: "Göre sırala",
    },
    {
      word: "country",
      fr: "pays",
      ar: "بلد",
      en: "country",
      tu: "ülke",
    }, //
    {
      word: "find on maps",
      fr: "Rechercher sur carte",
      ar: "ابحث في الخريطة",
      en: "find on maps",
      tu: "haritada ara",
    },
    {
      word: "Search",
      fr: "Chercher",
      ar: "ابحث",
      en: "Search",
      tu: "Arama",
    },
    {
      word: "Searching ...",
      fr: "Cherche encors ...",
      ar: "يتم البحث...",
      en: "Searching ...",
      tu: "Şu anda aranıyor ...",
    },
    {
      word: "cancel",
      fr: "annuler",
      ar: "إلغاء",
      en: "cancel",
      tu: "iptal etmek",
    },
    {
      word: "Card Request",
      fr: "demande de carte",
      ar: "طلب بطاقة",
      en: "Card Request",
      tu: "Kart Talebi",
    },
    {
      word: "Add your number code",
      fr: "Ajoutez votre numéro de code",
      ar: "أضف رقم الكود الخاص بك",
      en: "Add your number code",
      tu: "kod numaranızı ekleyin",
    },
    {
      word: "Please try a valide assurance number",
      fr: "Veuillez essayer un numéro d'assurance valide",
      ar: "الرجاء محاولة رقم تأمين صالح",
      en: "Please try a valide assurance number",
      tu: "Lütfen geçerli bir sigorta numarası deneyin",
    },
    {
      word: "Your request has been processed successfully",
      fr: "Votre demande a été traitée avec succès",
      ar: "لقد تمت معالجة طلبك بنجاح",
      en: "Your request has been processed successfully",
      tu: "İsteğiniz başarıyla işlendi",
    },
    {
      word: "Centre commercial",
      fr: "Centre commercial et d’affaires mohammadia mall cité djenina rez-de-chaussée no : 981 mohammadia Alger",
      ar: "مركز التجارة والأعمال الجنينة الطابق الارضي محل رقم 981 المحمدية الجزائرالعاصمة لقد تمت معالجة طلبك بنجاح",
      en: "Centre commercial et d’affaires mohammadia mall cité djenina rez-de-chaussée no : 981 mohammadia Alger",
      tu: "Centre commercial et d’affaires mohammadia mall cité djenina rez-de-chaussée no : 981 mohammadia Alger",
    },
    {
      word: "Redirecting to payment",
      fr: "Redirection vers la page de paiement ...",
      ar: "جارٍ التوجيه إلى صفحة الدفع ...",
      en: "Redirecting to payment ...",
      tu: "Ödeme sayfasına yönlendiriliyor ...",
    },
    {
      word: "Payment could not be initiated",
      fr: "Le paiement n'a pas pu être initié. Veuillez réessayer.",
      ar: "تعذر بدء عملية الدفع. يرجى المحاولة مرة أخرى.",
      en: "Payment could not be initiated. Please try again.",
      tu: "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
    },
    {
      word: "Verifying your payment",
      fr: "Vérification de votre paiement ...",
      ar: "جارٍ التحقق من الدفع ...",
      en: "Verifying your payment ...",
      tu: "Ödemeniz doğrulanıyor ...",
    },
    {
      word: "Payment successful",
      fr: "Paiement réussi ! Votre demande de carte a été enregistrée.",
      ar: "تم الدفع بنجاح! تم تسجيل طلب بطاقتك.",
      en: "Payment successful! Your card request has been recorded.",
      tu: "Ödeme başarılı! Kart talebiniz kaydedildi.",
    },
    {
      word: "Payment not completed",
      fr: "Le paiement n'a pas encore été confirmé. Aucune demande n'a été enregistrée.",
      ar: "لم يتم تأكيد الدفع بعد. لم يتم تسجيل أي طلب.",
      en: "Payment has not been confirmed yet. No request was recorded.",
      tu: "Ödeme henüz onaylanmadı. Herhangi bir talep kaydedilmedi.",
    },
    {
      word: "Payment failed",
      fr: "Paiement échoué",
      ar: "فشلت عملية الدفع",
      en: "Payment failed",
      tu: "Ödeme başarısız oldu",
    },
    {
      word: "No pending payment found",
      fr: "Aucun paiement en attente n'a été trouvé pour cette session.",
      ar: "لم يتم العثور على أي عملية دفع معلقة لهذه الجلسة.",
      en: "No pending payment was found for this session.",
      tu: "Bu oturum için bekleyen bir ödeme bulunamadı.",
    },
    {
      word: "Back to home",
      fr: "Retour à l'accueil",
      ar: "العودة إلى الرئيسية",
      en: "Back to home",
      tu: "Ana sayfaya dön",
    },
    {
      word: "Copy invoice id",
      fr: "Copier le numéro de facture",
      ar: "نسخ رقم الفاتورة",
      en: "Copy invoice id",
      tu: "Fatura numarasını kopyala",
    },
  ],
};
export const getters = {
    getT: (state) => (value) => {
        //return state.country.find((c) => c.name.en === value);
        let c = state.t.find((a)=>a.word.toLowerCase()===value.toLowerCase())
        if (c) {
            switch (state.lang) {
                case "en":
                    return c.en;
                case "fr":
                    return c.fr;
                case "ar":
                    return c.ar;
                case "tu":
                    return c.tu;
                default:
                    return value;
            }
        }else{
            return value
        }
    },
    getL(state) {
        return state.lang;
      },
  };
  export const mutations = {
    SET_lang(state, lang) {
        state.lang = lang;
    },
  }